import React, { useState, useEffect, useContext, useCallback } from "react";
import {
  Button,
  Divider,
  Grid,
  Modal,
} from "@material-ui/core";
import Select from "react-select";
import useStyles from "../../../components/styles/styles";
import Api from "../../../constant/Api";


const DriversOfCargoListModal = ({ open, setOpen ,driverOfCargoData,setApprovedDriver}) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [driversList, setDriversList] = useState([]);
  const [selectedCargoDriver, setSelectedCargoDriver] = useState(null);
  const handleClose = () => {
    setOpen(false);
  };

  console.log(driverOfCargoData);

  useEffect(() => {
    setLoading(true);
    const loadData = async () => {
      try {
        const config = {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            'Content-Type': 'application/json',
          }
        }
        const response = await fetch(`${Api.GetDriversOfCargo}?BarId=${driverOfCargoData.id}`, config);
        const data = await response.json();
        const modifiedData = data.data.lists.map((item) => {
          return {
            value: item.id,
            label: item.firstName + ' ' + item.lastName
          }
        })
        setDriversList(modifiedData);
      } catch (e) {
        console.log(e)
      } finally {
        setLoading(false);
      }
      
    };

    loadData();
  }, []);

  const selectCargoDriver = e => setSelectedCargoDriver(e);


  const confirm = async () => {

    try{
      console.log(Api.DriverApprovedToCargo)
      const body = {
        driverTransactionId: selectedCargoDriver.value
      }
  
      console.log(body)  
  
      const response = await fetch("https://apis.barmap.ir/api/App/Cargo/AppropriationCargoToDriver", {
        method: 'POST', // or 'PUT'
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem("token")}`
        },
        body: JSON.stringify(body),
      }).then(response => {
        if (response.ok) {
                setOpen(false)
        }
      }).catch(console.error)
    //  const data=await response.json()
    }catch(e){
      console.log(e)
    }
  
  };



 
  return (
    <Modal open={open}>
      <Grid container className={classes.newAddressModal}>
        <h3>
          انتخاب راننده
          <Divider style={{ width: "100%", margin: "10px 0 0" }} />
        </h3>
        <Grid container direction="column" wrap="nowrap">
         
        <Grid
              className={classes.colItem}
              item
              xl={4}
              lg={4}
              md={4}
              sm={12}
              xs={12}
            >
              <label>  انتخاب راننده</label>
              <Select
               onChange={(e) => selectCargoDriver(e)}
                        options={driversList}
                        value={selectedCargoDriver} 
                //onChange={e => setCarrier({ ...carrier, carrierTypeValue: e })}
                // options={carrier.carrierType}
                // value={carrier.carrierTypeValue}
                placeholder=" راننده را انتخاب کنید"
              />
            </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-end"
          style={{ paddingTop: "25px" }}
        >
          <Button
            onClick={() => setOpen(false)}
            variant="contained"
            style={{
              backgroundColor: "inherit",
              color: "inherit",
              width: 110,
              marginLeft: 10,
            }}
          >
            انصراف
          </Button>
          <Button
            variant="contained"
            style={{ backgroundColor: "#3CD4A0", color: "#fff", width: 110 }}
            onClick={()=>confirm()}
          >
            تایید
          </Button>
        </Grid>
      </Grid>
    </Modal>
  );
  // return (
  //   <Modal open={open} onClose={handleClose}>
  //     <Grid container className={classes.newAddressModal}>
  //       <Select
  //         onChange={(e) => selectCargoDriver(e)}
  //         options={driversList}
  //         value={selectedCargoDriver} 
  //         style={{ marginBottom: 16 }}
  //       />
  //       <Button style={{marginTop:16}} variant="contained" onClick={()=>confirm()}>تایید</Button>
  //     </Grid>
  //   </Modal>
  // );
};

export default DriversOfCargoListModal;
